import React from "react";
import { Box, Loader } from "@mantine/core";

const SimpleLoadingIndicator = ({ visible = false }) => {
  if (!visible) return null;

  return (
    <Box pos="absolute" top={12} right={12} sx={{ zIndex: 10 }}>
      <Loader size="sm" />
    </Box>
  );
};

export default SimpleLoadingIndicator;
